export const appModalId = 'app-modal';
